import { useEffect, useState } from 'react'
import { first } from 'rxjs/operators'
import { ReactState } from '../Types/Types'
import { $waitForElements } from '../../../NonReact/common/RxJS/WaitForElements'
import { ArrayUtils } from '../../../NonReact/utils/ArrayUtils'

export const useWaitForElements = (
    selector: string,
    ...allowedTopLevelElementSelector: string[]
): Nullable<HTMLElement[]> => {
    const [elements, setElements]: ReactState<Nullable<HTMLElement[]>> = useState<Nullable<HTMLElement[]>>(null)

    useEffect((): void => {
        $waitForElements(selector, ...allowedTopLevelElementSelector)
            .pipe(first((els: HTMLElement[]): boolean => !ArrayUtils.isEmpty(els)))
            .subscribe((els: HTMLElement[]): void => setElements(els))
    }, [selector, JSON.stringify(allowedTopLevelElementSelector)])

    return elements
}
